import { Provenienza } from "../../tipologiche/provenienza";
import { TipoDocumento } from "../../tipologiche/tipo-documento";

export class CensimentoDocumenti {
    id: string;
    tipoProvenienzaDocumento: Provenienza;
    tipoDocumento: TipoDocumento;
    quantita: number;
}
